import { useEffect, useState } from 'react';
import type { Locale } from '../../shared/i18n';
import { setLocalePreference } from '../api/client';
import { useI18n } from '../i18n/I18nProvider';

export function LanguageSwitcher({ enabledLocales, verified = false, preferredLocale }: { enabledLocales?: Locale[]; verified?: boolean; preferredLocale?: Locale | null }) {
  const { locale, setLocale, t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [selection, setSelection] = useState<Locale | 'auto'>(preferredLocale || 'auto');
  useEffect(() => setSelection(preferredLocale || 'auto'), [preferredLocale]);
  const options = enabledLocales?.length ? enabledLocales : ['en', 'ru'] as Locale[];
  if (options.length < 2) return null;
  const selected = verified ? selection : locale;
  const change = async (next: Locale | 'auto') => {
    const previous = locale;
    const previousSelection = selection;
    setSelection(next);
    if (next !== 'auto') setLocale(next);
    if (!verified) return;
    setBusy(true);
    try { const result = await setLocalePreference(next === 'auto' ? null : next); setLocale(result.locale); }
    catch { setSelection(previousSelection); setLocale(previous); }
    finally { setBusy(false); }
  };
  return <label className="language-switcher"><span className="visually-hidden">{t('common.language')}</span><select aria-label={t('common.language')} value={selected} disabled={busy} onChange={(event) => void change(event.target.value as Locale | 'auto')}>{verified && <option value="auto">{t('common.auto')}</option>}{options.map((option) => <option key={option} value={option}>{option === 'ru' ? 'RU' : 'EN'}</option>)}</select></label>;
}
